import { supabase } from "../Db_Connections/db_connection";

export async function getall() {
    const { data, error } = await supabase
        .from("profiles")
        .select("*")
        .order("id", { ascending: false });

    return { data, error };
}
//  READ (GET BY ID)

export async function getById(id) {
    const { data, error } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", id)
        .single();

    return { data, error };
}

export async function addprofile(data) {
    const { data: result, error } = await supabase
        .from("profiles")
        .insert([
            {
                // Name fields
                first_name: data.firstName,
                last_name: data.lastName,

                // Contact Info
                email: data.officialEmail,      // Form ka 'officialEmail' DB ke 'email' me jayega
                personal_email: data.personalEmail,
                phone: data.phone,

                // Personal Info
                dob: data.dob || null,          // Agar empty string ho to null bheje
                gender: data.gender,
                location: data.location,
                // 🔹 Profile Photo URL
                avatar_url: data.avatarUrl || null, 

                // Work Info
                department: data.department,
                designation: data.designation,
                role: data.role,
                employment_type: data.employmentType,
                joining_date: data.joiningDate || null, // Agar empty string ho to null bheje
                manager_name: data.managerName,

                // Security & Others
                temp_password: data.tempPassword,
                notes: data.notes,
                is_active: data.is_active ?? true, // Default true agar data me nahi hai
            },
        ])
        .select()
        .single();

    return { data: result, error };
}

export async function updateprofile(id, data) {
  // Build payload from incoming data (mapping)
  const payload = {
    first_name: data.firstName,
    last_name: data.lastName,

    email: data.officialEmail,
    personal_email: data.personalEmail,
    phone: data.phone,

    dob: data.dob || null,
    gender: data.gender,
    location: data.location,
      // 🔹 Profile Photo URL
      avatar_url: data.avatarUrl,

    department: data.department,
    designation: data.designation,
    role: data.role,
    employment_type: data.employmentType,
    joining_date: data.joiningDate || null,
    manager_name: data.managerName,

    temp_password: data.tempPassword,
    notes: data.notes,
    is_active: data.is_active,
  };

  // ✅ HARD BLOCK: never send these keys
  delete payload.employee_code;
  delete payload.employeeCode;

  // ✅ remove undefined values
  Object.keys(payload).forEach((k) => payload[k] === undefined && delete payload[k]);

  const { data: result, error } = await supabase
    .from("profiles")
    .update(payload)
    .eq("id", id)
    .select()
    .single();

  return { data: result, error };
}

export async function deleteprofiles(id) {
  // 1) unlink references in leaves
  const { error: e1 } = await supabase
    .from("leaves")
    .update({ approved_by: null })
    .eq("approved_by", id);

  if (e1) return { error: e1 };

  // 2) now delete profile
  const { error: e2 } = await supabase
    .from("profiles")
    .delete()
    .eq("id", id);

  return { error: e2 };
}
// 2. Login Check karne ke liye
export async function loginUser(email, password) {
    // Email se user dhundo
    const { data: user, error } = await supabase
        .from("profiles")
        .select("*")
        .eq("email", email)
        .single();

    if (error || !user) {
        return { error: "User not found or Email is incorrect" };
    }

    // Password Check (Temp Password compare kar rahe hain)
    if (user.temp_password !== password) {
        return { error: "Incorrect Password" };
    }

    // Account Active Check
    if (!user.is_active) {
        return { error: "Account is inactive. Contact Admin." };
    }

    return { data: user };
}
